export enum NODE_TYPE {
  ATTRIBUTE = 'Attribute',
  BLOCK = 'Block',
  ELEMENT = 'Element',
  LITERAL = 'Literal',
  TEMPLATE = 'Template',
}

export default abstract class Node {
  public type: NODE_TYPE;
  public value: string;

  constructor(type: NODE_TYPE, value: string) {
    this.type = type;
    this.value = value;
  }

  get isLiteral(): boolean {
    return this.type === NODE_TYPE.LITERAL;
  }

  get isElement(): boolean {
    return this.type === NODE_TYPE.ELEMENT;
  }
}
